const colNameRegex = /\(([^)]+)\)/;
function parseColName(colName) {
    let newName = colNameRegex.exec(colName);
    //@ts-ignore
    newName = newName ? newName[1].replace(/_/g, ' ') : colName;
    //@ts-ignore
    newName = newName.charAt(0).toUpperCase() + newName.slice(1);
    return newName;
}
function csvStringToArrays(csvString) {
    if (csvString) {
        const table = csvString
            .trim()
            .split('\n')
            .map((line) => line.trim().split(/,(?=(?:[^\"]*\"[^\"]*\")*(?![^\"]*\"))/));
        const withNumbers = table.map((row) => row.map((cell) => {
            const parsedCell = parseFloat(cell);
            return parsedCell || cell;
        }));
        return withNumbers;
    }
    return csvString;
}
function roundCellNumber(possibleNumber, decimalPoints = 2) {
    const cellInt = parseFloat(possibleNumber);
    if (cellInt) {
        const decQuoc = 10 ** decimalPoints;
        return Math.floor(cellInt * decQuoc) / decQuoc;
    }
    return possibleNumber;
}
function getTableQuocient(table) {
    const allValues = new Set();
    table.forEach((line) => line.forEach((cell) => {
        const cellInt = parseFloat(cell);
        if (cellInt) {
            allValues.add(cellInt);
        }
    }));
    const sortedValues = [...allValues].sort((a, b) => a - b);
    return sortedValues;
}
function sortValsWithNames(colNames, values) {
    const sortedWithNames = colNames
        .map((name, index) => ({ name, value: values[index] }))
        .filter((item) => typeof item.value === 'number')
        .sort((itemA, itemB) => itemB.value - itemA.value)
        .filter((item) => ![
        'number of events',
        'proportion of events used for learning',
        'number of users with event'
    ].includes(item.name.toLowerCase()));
    return sortedWithNames;
}
function sortInterests(table, interest) {
    //Change something to not use this function
    let index = 1;
    const output = [];
    for (let i = 1; i < table.length; i++) {
        if (table[i][0] === interest) {
            table[i].slice(1).forEach(function (item) {
                output.push({ name: table[0][index], value: item });
                index += 1;
            });
            break;
        }
        else {
            index += table[i].length - 1;
        }
    }
    return output
        .filter((item) => typeof item.value === 'number')
        .sort((itemA, itemB) => itemB.value - itemA.value);
}
export { sortValsWithNames, parseColName, roundCellNumber, csvStringToArrays, getTableQuocient, sortInterests };
